<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="income_list" />
    <IncomeList
      :incomes="filteredIncomes"
      :search-query="searchQuery"
      :loading="loading"
      @update:search-query="searchQuery = $event"
      @delete="deleteIncome"
    />
    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import IncomeList from "../../components/Income/IncomeList/IncomeList.vue";
import { useIncomeList } from "../../composables/useIncomeList";

export default defineComponent({
  name: "IncomeListPage",
  components: { MainHeader, MainSidebar, BreadcrumbMenu, IncomeList, MainFooter },
  setup() {
    return useIncomeList();
  },
});
</script>
